var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.899,
    height: 19,
    viewBox: "0 0 61.899 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1016 -479)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134 118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9,19.3,65.037.9h5.006L66.906,19.3Z",
    transform: "translate(1109.92 360.417)",
    fill: "#3a0068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.052.776A12.482,12.482,0,0,0,95.575,0c-4.97,0-8.46,2.5-8.46,6.063-.035,2.644,2.5,4.124,4.406,5.006,1.939.917,2.609,1.481,2.609,2.291,0,1.234-1.551,1.8-3,1.8a10.782,10.782,0,0,1-4.724-.952l-.7-.317L85,18.013A15.84,15.84,0,0,0,90.6,19c5.288,0,8.707-2.468,8.742-6.275.035-2.08-1.3-3.7-4.195-5.006-1.763-.846-2.82-1.41-2.82-2.291,0-.776.917-1.586,2.855-1.586a8.681,8.681,0,0,1,3.737.705l.458.212.67-3.983",
    transform: "translate(1094.963 361)",
    fill: "#3a0068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.559,1h-3.878a2.512,2.512,0,0,0-2.644,1.516L124.6,19.365h5.252s.846-2.256,1.057-2.75h6.416c.141.635.6,2.75.6,2.75h4.653L138.559,1M132.39,12.844C132.813,11.787,134.4,7.7,134.4,7.7c-.035.035.423-1.058.67-1.763l.352,1.586s.952,4.406,1.163,5.323Z",
    transform: "translate(1069.322 360.353)",
    fill: "#3a0068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.273.9,22.338,13.449l-.529-2.538A14.226,14.226,0,0,0,14.9,3.191L19.377,19.3H24.7L32.6.9H27.273",
    transform: "translate(1140.352 360.417)",
    fill: "#3a0068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.143.9H.071L0,1.288C6.31,2.8,10.469,6.5,12.2,10.911l-1.763-8.46A2.121,2.121,0,0,0,8.143.9",
    transform: "translate(1150 360.417)",
    fill: "#0abf8c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/Input.d32a67e1364acb3d84d73aab0cacdd53.svg";
export { ForwardRef as ReactComponent };